import { useI18n, useRouter } from '@popety_io/popety-io-lib'

import LegendSelector from '../../../../../components/LegendSelector'
import { pricingOptions } from '../../../../../utils/thematic/glossary/pricingOptions'
import {
  ESTIMATE_PURCHASE_APARTMENT,
  ESTIMATE_PURCHASE_HOUSE,
  ESTIMATE_RENT_APARTMENT,
  ESTIMATE_RENT_HOUSE,
} from '../../../../../config'

const SummaryMapContent = () => {
  const { t } = useI18n()
  const priceOptions = pricingOptions(t)
  const regex = /rent/
  const { query } = useRouter()
  const isRent = regex.test(query.summaryLayer || '')

  const options = [
    {
      value: ESTIMATE_PURCHASE_APARTMENT,
      label: t('estimate.map.legend.market price'),
    },
    {
      value: ESTIMATE_PURCHASE_HOUSE,
      label: t('estimate.map.legend.house_market_price'),
    },
    {
      value: ESTIMATE_RENT_APARTMENT,
      label: t('estimate.map.legend.market_rent_price_apartment'),
    },
    {
      value: ESTIMATE_RENT_HOUSE,
      label: t('estimate.map.legend.market_rent_price_house'),
    },
  ]

  return (
    <div>
      <LegendSelector
        options={options}
        legends={priceOptions?.[isRent ? 2 : 0]?.legend}
        value={ESTIMATE_PURCHASE_APARTMENT}
        keyValue="summaryLayer"
        legendValue="noise-legend"
        description={t('estimate.map.legend.market price description')}
      />
    </div>
  )
}

export default SummaryMapContent
